import { useSelector } from "react-redux";
import { selectCartLineItems } from "store/vino/cartSlice";
import { MiniCart } from "vino/components";
import { CartContextProvider } from "vino/context";

const CartContainer = ({ onClick }) => {
	const cartLineItems = useSelector(selectCartLineItems);

	return (
		<CartContextProvider cartLineItems={cartLineItems}>
			<MiniCart onClick={onClick} />
		</CartContextProvider>
	);
};

export default CartContainer;
